import React from 'react';

import { FILTERS, FILTERS_NAMES, TAGS_MAX_LENGTH } from '../../../constants/news';
import { sortTagsList } from '../../../helpers/news';
import { useTagsByRubric } from '../../../hooks/news';
import { Tag } from '../../Tags/components/Tag';
import { TagsSelection } from '../../Tags/components/TagsSelection';
import { TagsWrapper } from '../../Tags/components/TagsWrapper';
import styles from '../list-header.module.scss';

export interface ITagsProps {
  handleFiltersChange: (target: string, value: string | string[]) => void;
  filters: FILTERS;
  rubric: string;
}

export const Tags = ({ handleFiltersChange, filters, rubric }: ITagsProps) => {
  const tags = useTagsByRubric(rubric);

  const activeTags = filters[FILTERS_NAMES.TAG];
  const isActiveTagLimit = activeTags?.length >= TAGS_MAX_LENGTH;

  const handleTagChange = (value) => {
    handleFiltersChange(FILTERS_NAMES.TAG, value);
  };
  const tagsOptions = (tags || []).map((item) => ({ value: item.alias, label: item.name }));

  const mainTags = sortTagsList(
    isActiveTagLimit ? tagsOptions.filter((tag) => activeTags?.includes(tag.label)) : tagsOptions,
    activeTags,
  ).map((item) => {
    const active = activeTags?.includes(item.label);

    return (
      <Tag
        key={`tag-${item.value}`}
        onClick={() => handleTagChange(item.label)}
        closable={active}
        active={active}
        disabled={!active && isActiveTagLimit}
      >
        {item.label}
      </Tag>
    );
  });

  return (
    <>
      <TagsWrapper className={styles.tagsWrapper}>
        <TagsSelection
          isButtonVisible={tagsOptions?.length > 4}
          isButtonDisabled={isActiveTagLimit}
          activeTags={activeTags}
          tagsList={tagsOptions}
          handleTagChange={handleTagChange}
        />
        {mainTags}
      </TagsWrapper>
    </>
  );
};
